<template>
  <div id="page">
    <div class="cardFaceGroup">
      <div>
        <input id="cardFront" type="radio" v-model="showCardFront" name="cardFaceRd" value="0"></input>
        <label for="cardFront">正面</label>
        /
        <input id="cardBack" type="radio" v-model="showCardFront" name="cardFaceRd" value="1"></input>
        <label for="cardBack">背面</label>
      </div>
    </div>

    <div class="rootDiv" align="center">
      <div id="absoluteDiv" v-bind:class="isHorizontal ? 'absoluteDiv' : 'absoluteDiv vertical'">
        <img ref="frontCover" id="cardFrontCover" v-bind:class="isHorizontal ? 'cardFrontCover' : 'cardFrontCover frontCoverV'"
          v-bind:src="isHorizontal? frontCoverH:frontCoverV"></img>
        <img ref="frontImg" id="cardFrontImg" v-bind:class="isHorizontal ? 'cardFront' : 'cardFront frontV'" v-bind:src="cardFace" />
        <img ref="backCover" id="cardBackCover" v-bind:class="isHorizontal ? 'cardBackCover1' : 'cardBackCover1 backCoverV1'"
          v-bind:src="isHorizontal? backCoverH:backCoverV"></img>
        <img ref="backImg" id="cardBackImg" v-bind:class="isHorizontal ? 'cardBack' : 'cardBack backV'"></img>
      </div>
    </div>

    <div>
      <h5>请挑选您的专属卡底</h5>
      <div class="parent">
        <div class="RadioStyle item" v-for="(item, index) in kadis" :key="index">
          <input v-model="kadiColor" type="radio" :id="item.nameCN" name="kadiColorRd" :value="item.id">
          <label :for="item.nameCN" :style="{'background-color':item.hexCode}"></label>
        </div>
      </div>
    </div>


    <div>
      <h5>请挑选您的专属工艺</h5>
      <div class="chk_div imgDiv">
        <div v-for="(item, index) in kgys" :key="index">
          <input v-model="kagongyi" type="radio" :value="item.id" :id="item.technologyName" name="kgyRd">
          <label :for="item.technologyName" :style="{'background-image': 'url(' + item.technologyUrl + ')'}"></label>
        </div>
      </div>
    </div>

    <div align="center" class="actionArea">
      <b-button block variant="danger" style="width: 80%;" @click="submitOrder()">上传图片</b-button>
    </div>

    <b-modal ok-only ref="model_error" title="提示" @ok="handleOk" ok-title="确定">
      <p class="my-4">{{errorMsg}}</p>
    </b-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'UploadCardface',
    data() {
      return {
        cardFace: '',
        selectParam: null,
        cardOri: '',
        bankSerialNumber: '',
        kadiColor: '',
        kagongyi: '',
        showCardFront: '',
        isHorizontal: true,
        orderNo: '',
        bankCode: '',
        errorMsg: '',
        frontCoverH: 'https://cp.hengbao.net.cn:9010/dfs/group2/M00/00/00/xGJiVF6C4hCAXrR-AACa3EArW5U633.png',
        frontCoverV: 'https://cp.hengbao.net.cn:9010/dfs/group2/M00/00/00/xGJiVF6C5FiAWmX4AACJ6uw18KI751.png',
        backCoverH: 'https://cp.hengbao.net.cn:9010/dfs/group2/M00/00/00/xGJiVF6C4_GACkAKAAHBOX3GtCM709.png',
        backCoverV: 'https://cp.hengbao.net.cn:9010/dfs/group2/M00/00/00/xGJiVF6C5HqADfPPAAIB6rEaMEA016.png',
        kadis: [{
            id: 1,
            hexCode : '#AF002C',
            rgbCode:'',
            nameCN: 'AF002C',
            nameEN:'',
            isUsed: ''
          },
          {
            id: 2,
            hexCode : '#0084D4',
            rgbCode:'',
            nameCN: '0084D4',
            nameEN:'',
            isUsed: ''
          },
          {
            id: 3,
            hexCode : '#FFD900',
            rgbCode:'',
            nameCN: 'FFD900',
            nameEN:'',
            isUsed: ''
          }
        ],
        kgys: [{
          id: '1',
          technologyName: '工艺1',
          //technologyUrl: require('../../static/custom_card.jpg')
          // technologyUrl: 'https://cp.hengbao.net.cn:9010/dfs/group1/M00/00/00/MgAAaF4cKoWAAtBiAACw7PPQWTs417.png',
          technologyUrl: 'https://cp.hengbao.net.cn:9010/dfs/group2/M00/00/00/xGJiVF6C4hCAXrR-AACa3EArW5U633.png'
        }],
        cardTheme: ''
      }
    },
    watch: {
      kadiColor: function(newval, oldval) {
        console.log("当前卡底色：" + newval, "之前的卡底色：" + oldval);
        var img = this.$refs.backImg;
        for (let i = 0; i < this.kadis.length; i++) {
          let item = this.kadis[i];
          if (item.id == newval) {
            img.style.backgroundColor = item.hexCode;
            break;
          }
        }
      },
      showCardFront: function(newval, oldval) {
        console.log("当前显示卡面的值：" + newval, "之前显示卡面的值：" + oldval);
        var frontCover = this.$refs.frontCover;
        var frontImg = this.$refs.frontImg;
        var backCover = this.$refs.backCover;
        var backImg = this.$refs.backImg;
        if (newval == 0) {
          console.log("显示")
          frontCover.style.display = "";
          frontImg.style.display = "";
          backCover.style.display = "";
          backImg.style.display = "";
        } else {
          console.log("隐藏")
          frontCover.style.display = "none";
          frontImg.style.display = "none";
          backCover.style.display = "";
          backImg.style.display = "";
        }
      },
      kagongyi: function(newval, oldval) {
        console.log("卡工艺：" + newval, "之前显示卡工艺的值：" + oldval);
      }
    },
    methods: {
      handleOk: function(bvModalEvt) {

      },
      showErrorMsg: function() {
        this.$refs['model_error'].show();
      },
      hideErrorMsg: function() {
        this.$refs['model_error'].hide();
      },
      showLoading: function() {
        this.$showLoading(false, false, '上传中');
      },
      hideLoading: function() {
        this.$hideLoading();
      },
      submitAction: function() {
        if (this.selectParam != null && this.selectParam.isModify == 1) {
          this.modifyOrder()
        } else {
          this.submitOrder();
        }
      },
      submitOrder: function() {
        var that = this;
        that.showLoading();
        var blob = this.dataURLtoBlob(this.cardFace);
        var formData = new FormData();

        var myObj = {
          bankSerialNumber: this.bankSerialNumber,
          cardType: 1,
          cardTechnology: this.kagongyi,
          cardTypography: this.cardOri,
          backgroupColor: this.kadiColor,
          cardSubject: this.cardTheme.themeType,
          bankCode: this.bankCode
        };

        console.log(myObj);
        
        
        // String bankSerialNumber //针对每张卡片的唯一号
        // int cardType; //1-借记卡 / 2-信用卡
        // int cardTechnology; //工艺
        // int cardTypography //横版/竖版
        // int backgroupColor //底片颜色
        // int cardSubject //动物/人物/风景...
        // String bankCode //银行编号（用于区分银行）
        // MultipartFile facadeImage //上传的图片

        var formData = new FormData();
        formData.append("bankSerialNumber", myObj.bankSerialNumber);
        formData.append("cardType", myObj.cardType);
        formData.append("cardTechnology", myObj.cardTechnology);
        formData.append("cardTypography", myObj.cardTypography);
        formData.append("backgroupColor", myObj.backgroupColor);
        formData.append("backgroupColor", myObj.backgroupColor);
        formData.append("cardSubject", myObj.cardSubject);
        formData.append("bankCode", myObj.bankCode);

        formData.append('facadeImage', blob, 'facadeImage.png');

        axios({
          method: 'post',
          url: 'https://cp.hengbao.net.cn/pos/order/submitOrder',
          data: formData,
          onUploadProgress: function(progressEvent) {
            var percent = '0';
            var percentage = '0%';

            if (progressEvent.lengthComputable) {
              percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              percentage = percent + '%';
              console.log(percentage);
            }
          }
        }).then(function(response) {
          that.hideLoading();
          console.log(response);
          var result = response.data;
          /* {
            code: 0
            deadline: "20200523093922"
            message: "交易成功"
            notify_url: "http://196.98.98.101/pos/order/payOrder"
            orderDateTime: "2020-05-22 09:39:22"
            orderNo: "01248790113566597120"
            price: 1
            projectName: "DIY"
            thumbnailFileUrl: null
          } */
          if (result.code === 0) {
            that.toOrderPay(result);
          } else {
            /* {
              code: 1004
              deadline: null
              message: "银行唯一号不允许重复使用"
              notify_url: null
              orderDateTime: null
              orderNo: null
              price: null
              projectName: null
              thumbnailFileUrl: null
            } */
            that.errorMsg = result.message;
            that.showErrorMsg();
          }

        }).catch(function(error) {
          that.hideLoading();
          console.log(error);
        })
      },
      modifyOrder: function() {
        var blob = this.dataURLtoBlob(this.cardFace);
        var formData = new FormData();

        var myObj = {
          orderNo: this.selectParam.orderNo,
          backgroupColor: this.selectParam.backgroundColor
        }

        var formData = new FormData();
        formData.append("orderNo", myObj.orderNo);
        formData.append("backgroupColor", myObj.backgroupColor);

        formData.append('facadeImage', blob, 'facadeImage.png');
        axios({
          method: 'post',
          url: 'https://cp.hengbao.net.cn/pos/order/modify',
          data: formData,
          onUploadProgress: function(progressEvent) {
            var percent = '0';
            var percentage = '0%';

            if (progressEvent.lengthComputable) {
              percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              percentage = percent + '%';
              console.log(percentage);
            }
          }
        }).then(function(response) {
          console.log(response);
          var result = response.data;
          if (result.code === 0) {

          } else {

          }

        }).catch(function(error) {
          console.log(error);
        })
      },
      dataURLtoBlob: function(dataurl) {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {
          type: mime
        });
      },
      toOrderPay: function(orderObj) {
        var tempObj = {
          orderNo: orderObj.orderNo,
          orderDateTime: orderObj.orderDateTime,
          price: orderObj.price,
          projectName: orderObj.projectName,
          thumbnailFileUrl: orderObj.thumbnailFileUrl
        }

        var orderInfo = JSON.stringify(tempObj);
        this.$router.replace({
          name: 'OrderPay',
          params: {
            orderInfo: orderInfo
          }
        })
      }
    },
    mounted: function() {
      this.bankSerialNumber = this.$route.params.bankSerialNumber;
      this.bankCode = this.$route.params.bankCode;
      console.log('bankSerialNumber:' + this.bankSerialNumber);
      console.log('bankCode:' + this.bankCode);

      var destImg = localStorage.getItem('destImg');
      this.cardFace = destImg

      var selectParam = this.$route.params.selectParam;
      console.log('selectParam:' + selectParam)
      if (selectParam !== undefined) {
        this.selectParam = JSON.parse(selectParam)
      }

      let themeParam = this.$route.params.cardTheme;
      console.log('themeParam:' + themeParam)
      if (themeParam !== undefined) {
        this.cardTheme = JSON.parse(themeParam)
        this.kadis = this.cardTheme.backgroudColorList;
        this.kgys = this.cardTheme.cardTechnologyList;
      }

      this.cardOri = this.$route.params.cardOri;
      console.log('cardOri:' + this.cardOri);
      if (this.cardOri == 0) {
        //横版
        this.isHorizontal = true;
      } else if (this.cardOri == 1) {
        //竖版
        this.isHorizontal = false;
      }

      if (1 == this.kgys.length) {
        this.kagongyi = this.kgys[0].id;
      }

      this.showCardFront = 0;
    }
  }
</script>

<style scoped>
  .lefttext {
    text-align: left;
    padding-left: 8px;
    padding-right: 8px;
  }

  .actionArea {
    margin-top: 32px;
    margin-bottom: 24px;
  }

  .cardFront {
    position: absolute;
    z-index: 25;
    left: 10px;
    top: 10px;
    width: 255px;
    height: 144px;
  }

  .frontV {
    position: absolute;
    z-index: 25;
    width: 116px;
    height: 190px;
    left: 10px;
    top: 10px;
  }

  .cardFrontCover {
    position: absolute;
    z-index: 30;
    left: 10px;
    top: 10px;
    width: 255px;
    height: 144px;
  }

  .frontCoverV {
    position: absolute;
    z-index: 30;
    width: 116px;
    height: 190px;
    left: 10px;
    top: 10px;
  }

  .cardBack {
    position: absolute;
    z-index: 15;
    left: 20px;
    top: 20px;
    width: 255px;
    height: 144px;
  }

  .backV {
    position: absolute;
    z-index: 15;
    width: 116px;
    height: 190px;
    left: 20px;
    top: 20px;
  }

  .cardBackCover1 {
    position: absolute;
    z-index: 20;
    left: 20px;
    top: 20px;
    width: 255px;
    height: 144px;
  }

  .backCoverV1 {
    position: absolute;
    z-index: 20;
    width: 116px;
    height: 190px;
    left: 20px;
    top: 20px;
  }

  .absoluteDiv {
    position: relative;
    width: 300px;
    height: 190px;
  }

  .vertical {
    position: relative;
    width: 140px;
    height: 220px;
  }

  .rootDiv {
    position: relative;
    background-color: beige;
    margin-top: 8px;
    margin-bottom: 8px;
    padding-top: 16px;
    padding-bottom: 16px;
    width: 100%;
  }

  .cardFaceGroup {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    align-items: flex-end;
    height: 64px;
  }

  .cardFaceGroup input {
    display: none;
  }

  .cardFaceGroup label {
    color: gray;
    line-height: 28px;
    min-width: 20vw;
    min-height: 28px;
    text-align: center;
    border-radius: 4px;
    margin: 8px;
  }

  .cardFaceGroup input:checked+label {
    background-size: 21px 21px;
    font-weight: bold;
    color: black;
    margin: 8px;
  }

  .kadiItem {
    display: flex;
    width: 25%;
    height: 3rem;
  }

  .RadioStyle input {
    display: none
  }

  .RadioStyle label {
    border: 1px solid #00a4ff;
    color: #fff;
    line-height: 28px;
    min-width: 100%;
    min-height: 28px;
    text-align: center;
    float: left;
    font-size: 10px;
    border-radius: 4px;
  }

  .RadioStyle input:checked+label {
    border: 4px solid #00a4ff;
    background-size: 21px 21px;
    color: #fff;
  }

  .RadioStyle input:disabled+label {
    opacity: 0.7;
  }

  .parent {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 25%;
    height: 3rem;
    margin-left: 0.5rem;
    border-radius: 4px;
  }

  .imgDiv {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .chk_div input {
    display: none;
  }

  .chk_div label {
    background-size: 64px 48px;
    width: 64px;
    height: 40px;
    display: block;
    padding-left: 35px;
    padding-top: 5px;
    margin: 8px;
  }

  .chk_div input[type=radio]:checked+label {
    border: 4px solid #00a4ff;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UploadCardface.vue